const MessageSkeleton = () => {
  return (
    <div className="note-card note-card-skeleton" aria-hidden="true">
      <div className="note-card-header">
        <span className="skeleton skeleton-avatar" />
        <div className="note-card-id">
          <span className="skeleton skeleton-name" />
          <span className="skeleton skeleton-location" />
        </div>
      </div>
      <div className="skeleton skeleton-line" />
      <div className="skeleton skeleton-line" />
      <div className="skeleton skeleton-line short" />
    </div>
  );
};

export default MessageSkeleton;
